import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import fileClient from 'clients/fileClient';

export const fetchInvoices = (payload) => {
    return apiClient.read(`${ config.getApiBaseUrl() }/invoices`, payload);
};

export const exportInvoices = (payload) => {
    return apiClient.read(`${ config.getApiBaseUrl() }/invoices/export`, payload);
};

export const downloadInvoice = (id, fileName) => {
    return fileClient.getPDF(`${ config.getApiBaseUrl() }/invoices/${ id }/download`, fileName);
};

export const exportInvoicesLines = (payload) => {
    return apiClient.read(`${ config.getApiBaseUrl() }/invoice-transactions/export`, payload);
};



// WEBPACK FOOTER //
// ./src/http/requests/invoicesRequests.js